import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Setting } from '../../common/settings';
import url from 'src/settings.json';

@Injectable({
  providedIn: 'root'
})
export class HealthServiceService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      //Authorization: 'my-auth-token'
    }),
    params: new HttpParams()
  };
  setting: Setting = url;
  constructor(private readonly httpClient: HttpClient) { }

  connectBackEnd() {
    const url = `${this.setting.url}`;
    console.log(url);
    return this.httpClient.get(`${url}/GSC-ITSO-ADSCollection8/api/health/`)
  }
}
